<template>
     <div class="navbar navbar-expand-lg bg-light position-fixed top-0 shadow p-4 w-100 mb-5">
        <div>one</div>
        <div class="navtwo">
            <img src="../assets/images/videoicon.png" alt="">
            <img src="../assets/images/homeicon.jpg" alt="" width="40px" height="40px">
        </div>
        <div>three</div>
       
    </div>
  <div class="container-fluid shadow mt-5">
   
    <div class="row shadow justify-content-between">
      
      <div class=" bg-light childone col-md-3 d-md-block d-none d-sm-none">
        Lorem   dolor sit amet consectetur aelit. Assumenda, voluptates. Asperiores ut eveniet cum deleniti accusantium temporibus dolorum, recusandae digni
      </div>

    
      <div class="col-12 col-sm-12 col-md-5 two offset-md-3">
        <div class=" row shadow justify-content-around p-4 rounded-3"> 
      <div class="col-1">
  <img :src="`http://localhost:8000/profilepictures/`+profilepicture" alt="picture" height="50px" width="50px" style="border-radius: 100%; border: none;">
      </div>
      <div class="col-7">
<p>What's on you mind?</p>
      </div>
        </div>
      <div class="w-100 mx-auto shadow row p-5">
        <h5>See who you can follow</h5>
  <div
    class="d-flex overflow-auto gap-3 p-3 bg-light rounded shadow-sm"
    style="white-space: nowrap; height: 400px;"
  >
    <div
      class="card p-3 d-flex flex-column align-items-center"
      style="min-width: 300px;"
      v-for="student in allstudents"
      :key="student.student_id"
    >
    <div
  class="mb-4 rounded overflow-hidden"
  style="width: 100%; height: 400px;"
>
  <img
    :src="student.profilepicture
      ? `http://localhost:8000/profilepictures/${student.profilepicture}`
      : require('../assets/images/default.jpg')"
    alt="picture"
    style="width: 100%; height: 100%; object-fit: cover; display: block;"
    class="rounded"
  />
</div>

    <p>{{ student.fullname }}</p> 

      <div class="mt-5">
        <button class="btn btn-outline-primary" @click="follow(student.student_id)">Follow</button>
      </div>
    </div>
  </div>
</div>

        <div 
  class="col-12 shadow mb-4"
  v-for="post in allposts"
  :key="post.id"
  
>
  <div class="d-flex align-items-center gap-3 mb-2 p-3" v-if="post.student">
    <img
      :src="`http://localhost:8000/profilepictures/` + post.student.profilepicture"
      alt="profile"
      width="50"
      height="50"
      class="rounded-circle"
      style="object-fit: cover;"
    />
    <h5 class="mb-0">{{ post.student.fullname }}</h5>
  </div>

 
  <div class="mx-auto col-11">
<p class="mb-3 content">{{ post.content }}</p>
  </div>

 
  <div v-if="post.post_img" class="d-flex justify-content-center mt-3">
    <img
      :src="`http://localhost:8000/postimages/` + post.post_img"
      alt="post image"
      class="rounded"
      style="width: 100%; max-width: 600px; height: 400px; object-fit: cover;"
    />
    
</div>
<hr>
<div class="row justify-content-evenly">
        <div class="col-3 " >
          <p v-if="Array.isArray(post.likes)" class="text-primary">{{ post.likes.filter(like=>like.status==1).length }} Likes</p>
        </div>
        <div class="col-3" ><p>{{ post.comments.length }} comments</p></div>
      </div>
<div class="row justify-content-evenly p-3">
<div class="col-3 ms-5">
    <div v-if="post.likes.find(like=>like.student_id == this.userid && like.status==1 )" @click="likebutton(post.id)" style="cursor: pointer;" >
    <img src="../assets/images/liketwo.jpeg" alt="" width="15px" height="15px">
    <span class="text-primary d-none d-sm-none d-md-block" >Liked</span> 
</div>
<div v-else @click="likebutton(post.id)" style="cursor: pointer;">
  <img src="../assets/images/likeone.jpg" alt="" width="30px" height="30px"><span class="d-none d-sm-none d-md-block">Like</span>
</div>
</div>
<div class="col-3">
<div style="cursor: pointer;" @click="openmodal(post)" data-bs-toggle="modal" data-bs-target="#exampleModal">
         <img  src="../assets/images/messageicon.jpg" alt="" width="20px" height="20px"><span style="margin-left: 10px;" class="d-none d-sm-none d-md-block">comment</span>
     </div>
</div>
<div class="modal fade" id="exampleModal" tabindex="-1" aria-labelledby="exampleModalLabel" aria-hidden="true">
  <div class="modal-dialog modal-lg modal-dialog-scrollable">
    <div class="modal-content">
      <div class="modal-header">
        <!-- <h1 class="modal-title fs-5" id="exampleModalLabel">Modal title</h1> -->
        <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
      </div>
      <div class="modal-body ">
       <div v-if="selectedpostimage" class=" mx-auto">


    <div v-if="selectedpostimage.post_img" class="d-flex justify-content-center m-5">
        <img
      :src="`http://localhost:8000/postimages/` + selectedpostimage.post_img"
      alt="post image"
      class="rounded"
      style="width: 100%; max-width: 600px; height: 400px; object-fit: cover;"
    />
    </div>
      
    <div class="row justify-content-around p-5">
<div class="col-3">
   <div v-if="selectedpostimage.likes.find(like=>like.student_id == this.userid && like.status==1 )" @click="likebutton(selectedpostimage.id)" style="cursor: pointer;" >
    <img src="../assets/images/liketwo.jpeg" alt="" width="15px" height="15px"><span class="text-primary">Liked</span> 
</div>
<div v-else @click="likebutton(selectedpostimage.id)" style="cursor: pointer;">
  <img src="../assets/images/likeone.jpg" alt="" width="30px" height="30px"><span>Like</span>
</div>
</div>
<div class="col-3">
    <div style="cursor: pointer;" >
          <img  src="../assets/images/messageicon.jpg" alt="" width="20px" height="20px"><span style="margin-left: 10px;">comment</span>
     </div>
''</div>
<div class="col-3">
    <div style="cursor: pointer;" >
         <img  src="../assets/images/send.png" alt="" width="20px" height="20px"><span style="margin-left: 10px;">Send</span>
     </div>
</div>
<div >
    <div>
      <div  v-for="comment in selectedpostimage.comments" :key="comment.id">
     
     <div class="row justify-content-between my-3">
<img :src="`http://localhost:8000/profilepictures/`+comment.student.profilepicture" alt="picture" height="50px" width="50px" style="border-radius: 100%; border: none;" class="col-auto col-sm-auto col-xxl-auto">
     <div class="col-11 col-sm-8 col-xxl-9 p-3  shadow bg-body-secondary">
      <h5> {{ comment.student.fullname ?? ''}}</h5>
      <p> {{ comment.comment ??'' }}</p>
        <div style="cursor: pointer;">
  <img src="../assets/images/likeone.jpg" alt="" width="30px" height="30px"><span>Like</span> <span><button class="btn btn-success" @click="replyComment(comment.id)">Reply</button></span>
      
   
</div>


<div v-if="this.replycheck===comment.id" class="my-5">
  <p>Replying to {{ comment.student.fullname }} <button @click="cancelreply()">cancel</button></p>
    <textarea name="" id="" cols="" rows="" class="form-control my-2"  v-model="reply[comment.id]"></textarea> 
    <button class="btn btn-outline-primary" @click="replies(comment.id,selectedpostimage.id)">reply</button>

    
  </div>
  <div class="shadow my-5 bg-body text-dark rounded-1 col-9 mx-auto">
  <div  v-for="replies in comment.replies" :key="replies.id">
    <div class="row justify-content-between my-3 p-3 shadow ">
    <div class="col-2 col-xxl-auto col-auto col-sm-auto">
      <img :src="`http://localhost:8000/profilepictures/`+replies.student.profilepicture" alt="picture" height="50px" width="50px" style="border-radius: 100%; border: none;" class="img-fluid" >
    </div>
    <div class="col-5 col-xxl-9">
      <h5>{{ replies.student.fullname }}</h5>
        <p>{{ replies.reply }}</p>
        
    </div>
    </div>
    <hr>
      </div>
</div>
     </div>
     
     </div>
    

    </div>
    
    </div>
    
<div class="d-flex my-5">
          <img :src="`http://localhost:8000/profilepictures/`+profilepicture" alt="picture" height="50px" width="50px" style="border-radius: 100%; border: none;">
          <textarea
  cols="10"
  rows="4"
  class="form-control ms-4"
  v-model.trim="comment[selectedpostimage.id]"
  @focus="comment[selectedpostimage.id] === 'Comment as ' + fullname ? comment[selectedpostimage.id] = '' : null"
/>

</div>

       <div @click="commentpost(selectedpostimage.id)">
        
<img  src="../assets/images/send.png" alt="" width="20px" height="20px">
    </div>
</div>
    </div>
     
</div>

      </div>
    </div>
  </div>
</div>
<div class="col-3">
    <div style="cursor: pointer;" >
         <img  src="../assets/images/send.png" alt="" width="20px" height="20px"><span style="margin-left: 10px;">Send</span>
     </div>
</div>
</div>
</div>
      </div>

      <div class=" childthree col-md-2 d-md-block d-none d-sm-none">
        <!-- Lorem ipsum, dolor sit amet consectetur adipisicing elit... -->
        Lorem ipsum dolor sit amet, consectetur adipisicing elit. Nihil nulla libero vitae atque officia officiis illum et, quas consequuntur alias laudantium quisquam in possimus accusamus? Maxime fugit laborum sunt eius? Lorem ipsum dolor sit amet consectetur adipisicing elit. Laborum accusamus
      </div>

    </div>

  </div>
</template>

<script>
import axios from 'axios';
import { useCounterStore } from '@/stores/counter';
export default {
   
data(){
        return{
    check:false,
    box:false,
    checklike:{},
    followcomment:'follow',
    allposts:[],
        comment:{},
        reply:{},
        replycheck:null,
        selectedpostimage:null,
        allcomments:[],
    allusers:[],
    commentcheck:null,
    msg:'',
    allstudents:[],
    userid:"",
    fullname:"",
    file:'',
    allstudent:'',
    content:'',
    profilepicture:'',
    modalcheck:false,
    counter:useCounterStore()

        }
    },

  mounted(){
    
  setInterval(() => {
    
  }, 5000);
      this.userid=JSON.parse(localStorage.getItem('honeyuserid'))
      this.profilepicture=JSON.parse(localStorage.getItem('honeyprofilepicture'))
     console.log(this.userid);  
     
    
    axios.post('http://127.0.0.1:8000/api/allusers',{student_id:this.userid}).then((res)=>{
    // console.log(res.data);
    
        this.allstudents=res.data.allstudents
        console.log(this.allstudents);
        
        
    })
    axios.post('http://127.0.0.1:8000/api/allfollowing',{userid:this.userid}).then((res)=>{
        console.log(res.data);
        this.allposts=res.data.post
        
    })
    this.allposts.forEach(post => {
      console.log(post);
      
    });
    

 this.fullname=JSON.parse(localStorage.getItem('honeyfullname'))

 
  },
  
 methods:{
    viewstudent(index){
        localStorage.setItem('userindex',JSON.stringify(index))
        this.$router.push('/view')

    },
    follow(id){
        let user={
            follower_id:this.userid,
            follower_name:this.fullname,
            following_id:id
        }
        // console.log(user);
        
        axios.post('http://127.0.0.1:8000/api/follower',user).then((res)=>{
         console.log(res.data);
            if(res.data.status=='201'){
                this.msg=res.data.msg
            }
            else if(res.data.status=='205'){
                // this.$router.push('/login')
    //    this.msg=res.data.msg
       this.check=true
    
            }
            else if(res.data.status=='204'){
                // this.$router.push('/login')
       this.msg=res.data.msg
            }
            
        })
    },
    openmodal(post) {
  this.selectedpostimage = post;
  this.comment[this.selectedpostimage.id] = 'Comment as ' + this.fullname;

},



    handleChange(e){
// console.log(e.target.files[0]);
this.file=e.target.files[0]
console.log(this.msg);
    },
    createpost(){
        if(this.content===''){
      this.msg='This cannot be empty'

        }
        else{
            console.log(this.content);
            
        const post=new FormData()
        post.append('student_id',this.userid)
        post.append('content',this.content)
        post.append('image',this.file)
       axios.post('http://127.0.0.1:8000/api/post',post,{
        headers:{
            'Content-Type':'multipart/form-data'
        }
       })
       .then((res)=>{
          if(res.data.status=='200'){
            this.msg=res.data.msg
            this.content=''
            axios.post('http://127.0.0.1:8000/api/allfollowing',{userid:this.userid}).then((res)=>{
        console.log(res.data.post);
        this.allposts=res.data.post
    })
}
        console.log(res.data);
        
       })
       .catch((err)=>{
        console.log(err);
        
       })
    // 
      }
      setTimeout(() => {
        this.msg=''
      }, 3000);
    },
comments(postid){
    
    if(this.commentcheck===postid){
        this.commentcheck=null
    }
    else{
        this.commentcheck=postid
    }
},
    commentpost(postid){
     
        let comment={
          postid,
          studentid:this.userid,
          comment:this.comment[postid]
        }
        // console.log(comment);
        
        axios.post('http://127.0.0.1:8000/api/comment',comment)
       .then((res)=>{
        console.log(res.data);
        
        if(res.data){
            axios.post('http://127.0.0.1:8000/api/allfollowing',{userid:this.userid}).then((res)=>{
    // console.log(res.data);
    
        this.allposts=res.data.post
        if (this.selectedpostimage && this.selectedpostimage.id === postid) {
              this.selectedpostimage = this.allposts.find(post => post.id === postid);
            }

    })
    this.comment=''
        }
        console.log(res.data);
        
       })
       .catch((err)=>{
        console.log(err);
        
       })
    },
    replyComment(commentid){
      if(this.replycheck===commentid){
        this.replycheck=null
    }
    else{
        this.replycheck=commentid
    } 
  //  /  console.log(replyobj);
   
    },
    cancelreply(){
this.replycheck=null
    },
    replies(commentid,postid){
      let replyobj={
    commentid,postid,studentid:this.userid,
    reply:this.reply[commentid]
   }
    axios.post('http://127.0.0.1:8000/api/reply',replyobj).then((res)=>{
      if(res.data){
        this.replycheck=null
         
            // console.log(res.data);
            
            axios.post('http://127.0.0.1:8000/api/allfollowing',{userid:this.userid}).then((res)=>{
    
        this.allposts=res.data.post
         if (this.selectedpostimage && this.selectedpostimage.id === commentid) {
              this.selectedpostimage = this.allposts.find(post => post.id === commentid);
            }
       
        
    })
           

        console.log(res.data);
      }
      
    }).catch((err)=>{
      console.log(err);
      
    })
  
    },

    likebutton(postid){
      let like={
        postid,
        studentid:this.userid
      }
       axios.post('http://127.0.0.1:8000/api/like',like)
       .then((res)=>{
           if(res.data){
            console.log(res.data);
            
            axios.post('http://127.0.0.1:8000/api/allfollowing',{userid:this.userid}).then((res)=>{
    
        this.allposts=res.data.post
         if (this.selectedpostimage && this.selectedpostimage.id === postid) {
              this.selectedpostimage = this.allposts.find(post => post.id === postid);
            }
       
        
    })
           }
        
       })
       .catch((err)=>{
        console.log(err);
        
       })

},
 },
 
 
 computed:{

getcurrentuser(){
    return this.allstudents.find((student)=>student.student_id==this.userid);
},
  
  }
}

</script>

<style scoped>
.childone {
  position: fixed;
  top: 100px;
  left: 0;
  overflow-y: auto;
  height: calc(100vh - 100px);
  width: 25%;
}
.two{
    margin-top: 50px;
}
.modal-body{
    overflow-y: auto;
    max-height: 60vh;

}
.childthree {
 top:100px;
 right:0;
 position: fixed;
 overflow-y: auto;
 width: 25%;
 height:calc(100vh - 100px);
}
.navbar{
    display: grid;
    grid-template-columns:30%  50% 20% ;
    justify-content: space-between;
}
.navtwo{
    display: grid;
    place-content: center space-around;
    grid-template-columns: 20% 20% 20% 20%;
}
.postimage{
    overflow: hidden;
}
.content {
  text-align: justify;
}


/* .card{
    } */
</style>
